import env from './.env.json';
import rel from './.rel.json';

export const environment = {
    env: 'dev',
    test: false,
    production: false,
    version: env.npm_package_version + ' (dev)',
    build: rel.release,
    serverUrl: '',
    defaultLanguage: 'it-IT',
    supportedLanguages: [
        'it-IT',
        'en-GB'
    ],
    configFirebase: {
        apiKey: 'AIzaSyDe_Cck86Nigfb6sLFU3MnE-W3bh_FD2UA',
        authDomain: 'suitedreams-dev.firebaseapp.com',
        projectId: 'suitedreams-dev',
        storageBucket: 'suitedreams-dev.appspot.com',
        messagingSenderId: '1068518976569',
    },
    firebaseClientId: '1068518976569-odi8b26k2cl253l8s7vsij2j9f3cf9hb.apps.googleusercontent.com',
    scope: 'email profile'
};
